import React from 'react';
import { Prompt  } from "react-router-dom";

export default function PromptRouter({ when } ) {
  return (
    <Prompt when={when} message={"Des éléments n'ont pas été publié. C'est éléments ne seront pas sauvegardés. Voulez-vous vraiment quitter cette page ?"}/>
  )
}
